<template>
  <div class="cmp-wrapper">
    <basic-container>
      <el-form inline :model="formData" ref="orderManage">
        <el-select v-model="selectStore" @change="selectBtn">
          <el-option label="门店ID" value="1"></el-option>
          <el-option label="门店名称" value="2"></el-option>
        </el-select>
        <el-form-item prop="storeId1" v-if="selectStore == 1" style="margin-left:10px;">
          <el-input v-model="storeId1" placeholder="请输入门店ID"></el-input>
        </el-form-item>
        <el-form-item prop="storeId2" v-if="selectStore == 2" style="margin-left:10px;">
          <fuzzy-query
            ref="cusOption2"
            :valueId.sync="storeId2"
            typeKey="storeName"
            :option="cusOption2"
          ></fuzzy-query>
        </el-form-item>
        <el-form-item label="下单日期">
          <el-date-picker
            v-model="createTime"
            type="daterange"
            value-format="timestamp"
            :default-time="['00:00:00', '23:59:59']"
            style="margin-left:10px;width:500px;"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
        <el-form-item style="width:100%">
          <el-button type="success" @click="exportFile" size="small">导出</el-button>
        </el-form-item>
      </el-form>

      <el-tabs v-model="activeName" type="card" @tab-click="handleClick" style="">
        <el-tab-pane label="全部订单" name="-1"></el-tab-pane>
        <el-tab-pane label="已提交" name="1"></el-tab-pane>
        <el-tab-pane label="已取消" name="2"></el-tab-pane>
        <el-tab-pane label="已确认" name="3"></el-tab-pane>
        <el-tab-pane label="已完成" name="4"></el-tab-pane>
      </el-tabs>

      <el-table v-loading="loading" :data="tableData">
        <el-table-column label="订单号" align="center" width="150px" prop="orderId">
          <template slot-scope="scope">
            <el-button type="text" @click="toDetail(scope.row)">
            {{scope.row.orderId}}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="门店名称" align="center" width="150px" prop="storeName"></el-table-column>
        <el-table-column label="收货人" align="center" width="100px" prop="receiverName"></el-table-column>
        <el-table-column label="联系电话" align="center" width="120px" prop="receiverPhone"></el-table-column>
        <el-table-column label="商品数" align="center" width="100px" prop="unitSkuNum"></el-table-column>
        <el-table-column label="支付金额" align="center" width="120px" prop="orderAmount" sortable>
          <template slot-scope="scope">
            <span style="font-size:12px">{{scope.row.orderAmount}}元</span>
          </template>
        </el-table-column>
        <el-table-column label="交易状态" align="center" width="100px" prop="tradeStatusName"></el-table-column>
        <el-table-column label="下单时间" align="center" prop="tradeCreateTime" sortable>
          <template slot-scope="scope">
            <span>{{_formatDate(scope.row.tradeCreateTime)}}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer pager">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="formData.pageNumber"
          :page-size.sync="formData.pageSize"
          :page-sizes="[20, 30, 40, 50]"
          layout="total, sizes, prev, pager, next, jumper"
          :total.sync="total"
          background
        ></el-pagination>
      </div>
    </basic-container>
  </div>
</template>
<script>
import {dateTimeFormatter, exportFile, getBaseUrl} from '@/utils/utils.js'

export default {
  data() {
    return {
      selectStore:'1',
      storeId1:"",
      storeId2:"",
      activeName: '-1',
      cusOption: [],
      cusOption2:[],
      createTime:[],
      formData: {
        status: '-1',
        startTime: "",
        endTime: "",
        storeId: null,
        pageNumber: 1,
        pageSize: 20
      },
      total: 0,
      loading: false,
      tableData: [],
      pickerOptions: {
          disabledDate(time) {
            let cur_time = new Date(new Date().toLocaleDateString()).getTime();
            return time.getTime() > cur_time + 86400000 - 1000 || time.getTime() < (Date.now() - 3600 * 1000 * 24 * 30);
          },
        },
    };
  },
  created() {
    this.search()
  },
  watch: {
    "createTime": {
      handler: function(val) {
        if (val.length > 0) {
          const [start_time, end_time] = val;
          Object.assign(this.formData, { startTime: start_time/1000, endTime: end_time/1000 });
        }else{
          Object.assign(this.formData, { startTime: "", endTime: ""});
        }
      }
    },
    "storeId1":{
      handler: function(val) {
        this.formData.storeId = val
      }
    },
    "storeId2":{
      handler: function(val) {
        this.formData.storeId = val
      }
    }
  },
  methods: {
    selectBtn(val){
      this.formData.storeId = this.storeId1
      if(val == "2"){
        this.formData.storeId = this.storeId2
      }
    },
    toDetail(row){
      if(row){
        this.$router.push({
          path: "/orderManagement/detail",
          query: {
            storeId:row.storeId,
            orderId:row.orderId
          }
        });
      }
    },
    _formatDate (ct) {
      return ct ? dateTimeFormatter(ct*1000, 'YYYY-MM-DD HH:mm:ss') : '--'
    },
    handleClick(tab, event) {
      this.formData.status = this.activeName
      this.search()
    },
    search() {
      this.formData.pageNumber = 1;
      this.getList();
    },
    async getList() {
      this.loading = true;
      const {
        ret,
        data: { list, totalCount }
      } = await _api.order.getList(this.formData);
      if (ret && list) {
        this.tableData = list || [];
        this.total = totalCount;
      }
      this.loading = false;
    },
    // 重置
    reset() {
      this.storeId1 = ""
      this.storeId2 = ""
      this.formData.storeId = ""
      if(this.$refs["cusOption2"]){
        this.$refs["cusOption2"].reset()
      }
      this.$refs["orderManage"].resetFields();
      this.createTime = []
    },
    handleCurrentChange(val) {
      this.getList();
    },
    handleSizeChange(val) {
      this.formData.pageNumber = 1;
      this.getList();
    },
    //导出
    async exportFile() {
      if (this.formData.startTime == "" || this.formData.endTime == "") {
        this.$message({
          type: "warning",
          message: "请选择下单日期,范围限制【近3天内】"
        });
        return;
      }

      if (this.formData.endTime - this.formData.startTime > 259200) {
        this.$message({
          type: "warning",
          message: "下单日期范围限制【近3天内】"
        });
        return;
      }

      if (this.total > 20000) {
        this.$message({
          type: "warning",
          message: "导出数据需≤20000条，请减少导出量"
        });
        return;
      }
      this.$message({
        type: "warning",
        message: "正在导出，请稍后"
      });

      exportFile(`${getBaseUrl()}/dmall-manage/dmallmanage/order/export`,this.formData,'订单数据.xlsx')
    },
  }
};
</script>
<style>
.img li{ 
  float:left;
  margin-left:5px; 
  list-style-type:none;
}
</style>